// extracted by mini-css-extract-plugin
export default {"items":"CheckboxGroup_items__f6OoO","checkBox":"CheckboxGroup_checkBox__XrtD2"};